import React, { useState, useEffect } from "react";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import { useParams, Link, useNavigate } from "react-router-dom";

import {
  Grid,
  Checkbox,
  Button,
  Typography,
  IconButton,
  makeStyles,
  List,
  ListItem,
  ListItemText
} from "@material-ui/core";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import update from "immutability-helper";

import { RENOTIFY_APPLICANTS_MUTATE } from "../../graphQL/term_applicant_qry";


var findAnd = require("find-and");

const useStyles = makeStyles((theme) => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
}));

export default function SelectUnQualifiedApplicantsDialog({ 
  termUuid, 
  checkList,
  applySelections,
  closeDialog,  

}) {
  console.log(checkList)
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  
  const navigate = useNavigate(); 

  const [renotifyApplicants] = useMutation(
    RENOTIFY_APPLICANTS_MUTATE
  );

  const handleProceed = async() => {
    let qualifiedApplicantIds = [];
    
    checkList.map((app, index) => {        
      qualifiedApplicantIds.push(parseInt(app.termApplicantId));
    });
    
    console.log('qualifiedApplicantIds',qualifiedApplicantIds)
        
    const { data, error } = await renotifyApplicants({
      variables: {
        qualifiedApplicantIds: qualifiedApplicantIds        
      },
    });
    if (error) {
      console.log("Error", error, data);       
    } else {
      console.log("Success in notified applicants"); 
      handleClose();     
    }
  }

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };
  
  

 return (
    <div style={{ width: "100%", minWidth: 600}}>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              minWidth: "600px"
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Grid
            container
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={11}
              style={{
                textAlign: "center",
                paddingLeft: 15,
              }}
            >
              Promoting Unqualified Applicants
            </Grid>
            <Grid item xs={1}>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent dividers>
          <DialogContentText sx={{ mb: 2 }}>
            You are about to promote the following unqualified applicants to qualified status.
            Are you sure you want to do this?
          </DialogContentText>

          {/* ✅ List selected applicants */}
          <List dense>
            {checkList.map((item) => (
              <ListItem key={item.termApplicantId}>
                <ListItemText
                  primary={item.applicantName}
                />
              </ListItem>
            ))}
          </List>

          <DialogContentText sx={{ mt: 2, color: "text.secondary" }}>
            This will send a special email to the above unqualified applicants informing them
            that they are promoted to the qualified (or accepted) status.
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ justifyContent: "center" }}>
         
              <Box mb={2}>
                <Button
                  variant="contained"
                  color="primary"              
                  className={classes.buttonStyle}
                  style={{ marginRight: 5, width: "170px" }}
                  onClick={handleProceed}
                  title="Yes, Proceed"
                >
                  Yes, Proceed
                </Button>
                <Button
                  variant="text"
                  color="primary"
                  className={classes.outlinedButtonStyle}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
              </Box>
          
        </DialogActions>
      </Dialog>
    </div>
  );
}

